import { apiClient } from './client';
import { AuditLogEntry } from '../types/admin';

/** Generic per-record tracking, for ordinary users - see src/controllers/audit.controller.ts. */
export const trackingApi = {
  forEntity: (entityType: string, entityId: number) =>
    apiClient.get<{ data: AuditLogEntry[] }>(`/api/audit?entityType=${encodeURIComponent(entityType)}&entityId=${entityId}`),
  mine: () => apiClient.get<{ data: AuditLogEntry[] }>('/api/employees/me/audit'),
};
